export { default } from 'onyx-common/string-template'
